// @ts-nocheck
function generateRandomSuffix(str, usedNumbers, min = 1000, max = 9999) {
  const regex = /(\d+)(?!.*\d)/;
  const match = str.match(regex);
  if (!match) {
    console.warn("字符串末尾没有找到数字部分，返回原字符串");
    return str;
  }
  const originalSuffix = match[1];
  let randomNum;
  do {
    randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    if (usedNumbers.size >= max - min + 1) {
      throw new Error("无法生成不重复的随机数，范围太小");
    }
  } while (usedNumbers.has(randomNum));
  usedNumbers.add(randomNum);
  return str.replace(regex, randomNum.toString());
}

export default function Adx(props: any) {
  let { id, rect, slot, style } = props;
  const usedNumbers = new Set();
  id = generateRandomSuffix(id, usedNumbers);
  useEffect(() => {
    try {
      window.googletag = window.googletag || { cmd: [] };
      googletag.cmd.push(function () {
        googletag.defineSlot(slot, rect, id).addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
      });
      googletag.cmd.push(function () {
        googletag.display(id);
      });
      console.log("adx广告代码执行了:", id);
      return () => {};
    } catch (error) {}
  }, []);
  return (
    <div style={{ textAlign: "center" }}>
      <div id={id} style={style}></div>
    </div>
  );
}
